/* hs-eslint ignored failing-rules */
/* eslint-disable react/jsx-no-literals */

import { Fragment, memo } from 'react';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import UIFlex from 'UIComponents/layout/UIFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getAddress, getLongitude, getLatitude, getName } from 'conversations-message-history/attachments/operators/locationAttachmentGetters';
import { buildLocationAttachmentUrl } from 'conversations-message-history/attachments/operators/buildLocationAttachmentUrl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LocationTitle = styled.div.withConfig({
  displayName: "LocationAttachment__LocationTitle",
  componentId: "sc-1tx8bbt-0"
})(["margin:5px 0;"]);
const LocationData = styled.div.withConfig({
  displayName: "LocationAttachment__LocationData",
  componentId: "sc-1tx8bbt-1"
})(["font-weight:600;"]);
const StyledIcon = styled(UIIcon).withConfig({
  displayName: "LocationAttachment__StyledIcon",
  componentId: "sc-1tx8bbt-2"
})(["font-size:18px;margin:2px 10px 0 -2px;"]);
const LocationAttachment = ({
  locationMetadata
}) => {
  const name = getName(locationMetadata);
  const address = getAddress(locationMetadata);
  const latitude = getLatitude(locationMetadata);
  const longitude = getLongitude(locationMetadata);
  const googleMapsLink = buildLocationAttachmentUrl(locationMetadata);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(LocationTitle, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.common-message.attachmentRendering.sharedLocation"
      })
    }), /*#__PURE__*/_jsxs(UIFlex, {
      align: "start",
      justify: "start",
      direction: "row",
      wrap: "nowrap",
      children: [/*#__PURE__*/_jsx(StyledIcon, {
        name: "location"
      }), /*#__PURE__*/_jsxs("div", {
        "data-test-id": "metadata",
        className: "location-metadata",
        children: [name && /*#__PURE__*/_jsx(LocationData, {
          children: name
        }), address && /*#__PURE__*/_jsx(LocationData, {
          children: address
        }), /*#__PURE__*/_jsxs(UILink, {
          "data-test-id": "google-maps-link",
          href: googleMapsLink,
          target: "_blank",
          children: [latitude, ", ", longitude]
        })]
      })]
    })]
  });
};
LocationAttachment.displayName = 'LocationAttachment';
export default /*#__PURE__*/memo(LocationAttachment);